import { useId, type ReactNode } from 'react';
import type { CardGridContent } from './service-content';

export interface WorkspacesStripProps {
  content: CardGridContent;
  cta: ReactNode;
}

/** The Seed Financing Package's two workspaces, from the CMS block, as one strip. */
export function WorkspacesStrip({ content, cta }: WorkspacesStripProps) {
  const headingId = useId();
  const items = content.cards ?? [];
  return (
    <section
      aria-labelledby={content.title ? headingId : undefined}
      className="bg-surface-card border-border-subtle rounded-card flex flex-col gap-5 border p-6"
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex max-w-2xl flex-col gap-2">
          {content.eyebrow && (
            <p className="text-dkgreen text-xs font-semibold tracking-wide uppercase">
              {content.eyebrow}
            </p>
          )}
          {content.title && (
            <h3 id={headingId} className="text-h4 text-navy">
              {content.title}
            </h3>
          )}
          {content.subtitle && (
            <p className="text-text-secondary text-sm leading-6">{content.subtitle}</p>
          )}
        </div>
        {cta}
      </div>
      {items.length > 0 && (
        <ul className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {items.map((item, index) => (
            <li key={index} className="bg-page-bg flex flex-col gap-1 rounded-lg p-4">
              <span className="text-navy text-sm font-semibold">{item.title}</span>
              {item.body && (
                <span className="text-text-secondary text-sm leading-6">{item.body}</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
